<script setup lang="ts">
import { RouterView } from 'vue-router'
import ErrorBoundary from '@/components/ErrorBoundary.vue'

// [I001.4] Global error handler for unhandled errors
const handleGlobalError = (error: Error) => {
  console.error('[App] Global error caught:', error)
  // Additional error reporting could be added here (e.g., Sentry, LogRocket)
}
</script>

<template>
  <!-- [I001.4] Wrap entire app in ErrorBoundary for global error catching -->
  <ErrorBoundary :onError="handleGlobalError">
    <RouterView />
  </ErrorBoundary>
</template>

<style scoped>
/* Clean app container */
</style>